// extracted by mini-css-extract-plugin
export default {"dropzone":"pngDropzone_dropzone__8YXNi","imagePreview":"pngDropzone_imagePreview__q468Y","cancel":"pngDropzone_cancel__nVOOf"};